module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/user-d03f0db3c48198d764a3c3f6acfd216c.svg";